<template>
  <v-data-table
    :headers="tabela.headers"
    :items="relatorio.unidades"
    :search="tabela.opcoes.pesquisa"
    :custom-filter="customFilter"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
    item-key="id"
    show-expand
    single-expand
  >
    <template v-slot:top>
      <!-- Ordenação e Pesquisa -->
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Cursos Cadastrados (Botão de Expansão) -->
    <template
      v-slot:[`item.data-table-expand`]="{
        item,
        expand,
        isExpanded,
      }"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="100%"
            text
            width="100%"
            @click="expand(!isExpanded)"
            v-on="on"
          >
            <v-badge right>
              <template v-slot:badge>
                <span>{{ item.cursosCapacitacao.length }}</span>
              </template>
              <v-icon
                color="grey lighten-0"
                large
              >
                school
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Clique para exibir os cursos</span>
      </v-tooltip>
    </template>

    <!-- Cursos Cadastrados (Lista Expandida) -->
    <template v-slot:expanded-item="{ headers, item }">
      <td
        :colspan="headers.length"
        class="justify-center"
      >
        <v-row dense>
          <v-spacer />
          <v-col>
            <v-row class="justify-center">
              <app-title texto="CURSOS CADASTRADOS" />
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-simple-table class="elevation-0 mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      INSTRUTOR
                    </th>
                    <th>
                      NOME DO CURSO
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="curso in item.cursosCapacitacao"
                    :key="curso.id"
                  >
                    <td>
                      <span class="grey--text text--darken-2">{{
                        curso.servidor
                      }}</span>
                    </td>
                    <td width="60%">
                      <span class="grey--text text--darken-2">{{
                        curso.nome
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-spacer />
        </v-row>
      </td>
    </template>

    <!-- Total -->
    <template v-slot:[`body.append`]>
      <tr>
        <td align="center" colspan="2">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td align="center">
          <strong>{{ relatorio.quantidadeInstrutorCapacitacao }}</strong>
        </td>
        <td align="center">
          <strong>{{ relatorio.quantidadeNaoInstrutorCapacitacao }}</strong>
        </td>
        <td align="center">
          <strong>{{ relatorio.quantidadeNaoRespondeuInstrutorCapacitacao }}</strong>
        </td>
        <td align="center">
          <strong>{{ relatorio.quantidadePerfis }}</strong>
        </td>
        <td align="center">
          <strong>{{ relatorio.quantidadeCursosCapacitacao }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { pesquisar } from '@/modules/texto';

export default {
  name: 'TabelaResultadoGeralFormacaoCapacitacao',

  components: {
    AppTitle,
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          { text: 'UNIDADE', value: 'nome', sortable: false },
          { text: 'SIGLA', value: 'sigla', sortable: false },
          {
            text: 'INTERESSADOS EM INSTRUTORIA DE CAPACITAÇÃO',
            value: 'quantidadeInstrutorCapacitacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'NÃO INTERESSADOS EM INSTRUTORIA DE CAPACITAÇÃO',
            value: 'quantidadeNaoInstrutorCapacitacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'NÃO RESPONDEU',
            value: 'quantidadeNaoRespondeuInstrutorCapacitacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'TOTAL DE SERVIDORES',
            value: 'quantidadePerfis',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'CURSOS CADASTRADOS',
            value: 'data-table-expand',
            width: '10%',
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'nome',
          selecionado: { id: 'nome', descricao: 'Unidade' },
          lista: [
            { id: 'nome', descricao: 'Unidade' },
            { id: 'sigla', descricao: 'Sigla' },
            {
              id: 'quantidadeInstrutorCapacitacao',
              descricao: 'Interessados em Instrutoria de Capacitação',
            },
            {
              id: 'quantidadeNaoInstrutorCapacitacao',
              descricao: 'Não Interessados em Instrutoria de Capacitação',
            },
            { id: 'quantidadeNaoRespondeuInstrutorCapacitacao', descricao: 'Não Respondeu' },
            { id: 'quantidadePerfis', descricao: 'Total de Servidores' },
            { id: 'cursosCapacitacao.length', descricao: 'Cursos Cadastrados' },
          ],
        },
      },
    };
  },

  methods: {
    customFilter(value, search, item) {
      return (
        pesquisar(item.unidade, search)
        || pesquisar(item.sigla, search)
        || item.cursosCapacitacao.some((c) => pesquisar(c.servidor, search) || pesquisar(c.nome, search))
      );
    },
  },
};
</script>
